import _ from 'underscore';
import { ProjectionGridBaseColumn } from '@bingads-webui/projection-grid-base-column';
import { getFieldValueFromGridData } from '@bingads-webui-campaign/recommendation-core';

export class StoreCountryColumn extends ProjectionGridBaseColumn {
  constructor({ i18n, newI18n }) {
    const title = newI18n.getString(_TL_('Store & Country'));
    super({
      name: 'StoreCountry',
      property: 'Opportunities/StoreCountry',
      title,
      bodyClasses: ['grid-column-storeCountry'],
      colClasses: ['col-middleText'],
      sortable: false,
      type: 'string',
      helpId: 'pop_BA_Store_Country',
      helpAriaLabel: i18n.getString('Click to learn more about {{item}}', { item: title }),
    });
    this.i18n = i18n;
    this.newI18n = newI18n;
  }

  template({
    value: {
      GridData,
      StoreName,
      CountryCode,
    },
  }) {
    const storeId = `ID: ${getFieldValueFromGridData(GridData, 'StoreId')} <br/>`;
    const storeName = `${this.newI18n.getString(_TL_('Name'))}: ${StoreName} <br/>`;
    const country = !_.isUndefined(this.i18n.getString(`UserCountry_${CountryCode}`)) ?
      this.i18n.getString(`UserCountry_${CountryCode}`) : CountryCode;
    const countryname = `${this.newI18n.getString(_TL_('Country/region'))}: ${country}`;
    return storeId + storeName + countryname;
  }

  get property() {
    return {
      get: item => _.first(item.Opportunities),
    };
  }
}
